const ENDPOINT = 'GETpendingArtistsRequests';
function getPendingArtistsRequests(gateway, params) {
    if (!params)
        return null;
    return gateway.get(getPendingArtistsRequests.endpoint, params);
}
getPendingArtistsRequests.endpoint = ENDPOINT;

export { getPendingArtistsRequests as default };
//# sourceMappingURL=getPendingArtistsRequests.js.map
